import React from 'react';
import { connect } from 'react-redux';
import FormQuestion from './common/FormQuestion';
import Paper from 'material-ui/Paper'

class DocFormQuestions extends React.Component {
    
    shouldComponentUpdate(nextProps, nextState) {
        const formQuestions = this.props.gorgon.formQuestions 
        const nextFormQuestions = nextProps.gorgon.formQuestions
        if (formQuestions !== nextFormQuestions) {
            return true;
        }
       
        return false
    }  

    render(){
        const { gorgon } = this.props;
        
        return (
            <div>
                <Paper>
                    <div className="container">
                        {gorgon.formQuestions.map((formQuestion)=>{
                            return (
                                <div className='row' key={formQuestion.id}>  
                                    <div className='col-sm'>
                                        <FormQuestion formQuestion={formQuestion} changeFieldValue={this.props.changeFieldValue} /> 
                                    </div>
                                </div>
                            )
                        })}   
                    </div>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gorgon: state.gorgon
    }
}

export default connect(mapStateToProps)(DocFormQuestions);


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/DocFormQuestions.js